import "@enos-monorepo/lib/locales/i18n";
import "./global.css";

import {
  setupAxios,
  useAuthStore,
  useCommonStore,
  useLanguageStore,
} from "@enos-monorepo/lib";
import { idbKeyvalStorage } from "@enos-monorepo/lib/utils/idbKeyvalStorage";
import * as Sentry from "@sentry/react";
import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import { QueryClient } from "@tanstack/react-query";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { StrictMode } from "react";
import * as ReactDOM from "react-dom/client";
import { Toaster } from "react-hot-toast";
import { BrowserRouter } from "react-router";
import { createJSONStorage } from "zustand/middleware";

import { App } from "./pages/app";

useAuthStore.persist.setOptions({
  storage: createJSONStorage(() => idbKeyvalStorage),
});

useCommonStore.persist.setOptions({
  storage: createJSONStorage(() => idbKeyvalStorage),
});

useLanguageStore.persist.setOptions({
  storage: createJSONStorage(() => idbKeyvalStorage),
});

Sentry.init({
  dsn: "https://873809fd12291c8b29e5bcf3045574e0@o4508552591638528.ingest.de.sentry.io/4508552743616592",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  enabled: import.meta.env.PROD,
});

setupAxios(useAuthStore, import.meta.env.VITE_API_BASE_URL);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 60 * 24, // 24 hours
      refetchOnWindowFocus: false, // default: true
    },
  },
});

const asyncStoragePersister = createAsyncStoragePersister({
  storage: idbKeyvalStorage,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <StrictMode>
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister: asyncStoragePersister,
      }}
    >
      <BrowserRouter>
        <Toaster />
        <App />
      </BrowserRouter>
    </PersistQueryClientProvider>
  </StrictMode>,
);
